import React, { useEffect, useState, useRef, useContext } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { AppBar, Toolbar, Box, Button, Slide, IconButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';

const Header = ({ headerShow, setHeaderShow, onMenuClick }) => {
  const lastScrollY = useRef(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentY = window.scrollY;
      const diff = currentY - lastScrollY.current;

      if (diff < -5) setHeaderShow(true);
      else if (diff > 5) setHeaderShow(false);

      lastScrollY.current = currentY;
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <Slide appear={false} direction="down" in={headerShow} timeout={{ enter: 500, exit: 100 }}>
      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          bgcolor: '#ffffff',
          color: 'text.primary',
          zIndex: (theme) => theme.zIndex.drawer + 1,
          borderTop: (theme) => `solid 8px ${theme.palette.primary.main}`,
          borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
        }}
      >

        <Toolbar >
          <IconButton
            color="inherit"
            edge="start"
            onClick={onMenuClick}
            sx={{ display: { md: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
          {/* ロゴ */}
          <Box component={RouterLink} to="/" sx={{ display: 'flex', alignItems: 'center' }}>
            <Box
              component="img"
              src={`${process.env.REACT_APP_IMAGE_BASE_URL}${process.env.REACT_APP_LOGO}`}
              alt={'Tendenec'}
              sx={{ maxWidth: '100%', maxHeight: 70 }}
            />
          </Box>
        </Toolbar>
      </AppBar>
    </Slide >
  );
};

export default Header;
